import { Cell, Grid } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { useProntuarioFamiliarQuery } from 'graphql/hooks.generated'
import { Fragment, useState } from 'react'
import { CondicoesMoradiaSection } from 'view/visualizacao-imovel/components/CondicoesMoradiaSection'
import { FamiliaSection } from 'view/visualizacao-imovel/components/FamiliaSection'
import { VisualizarImovelHeaderContent } from 'view/visualizacao-imovel/components/VisualizarImovelHeaderContent'
import { convertImovelDtoToImovelHeaderDto } from 'view/visualizacao-imovel/visualizacao-imovel-converter'

import { EstadoBotaoProntuarioFamiliar, ProntuarioFamiliarButtonGroup } from './ProntuarioFamiliarButtonGroup'
import { SemFamiliaContainer } from './SemFamiliaContainer'
import { ProntuarioFamiliarVisitasListSection } from './visita-domiciliar/ProntuarioFamiliarVisitasListSection'

interface ProntuarioFamiliarViewProps {
  cidadaoId: string
}

export const ProntuarioFamiliarView = ({ cidadaoId }: ProntuarioFamiliarViewProps) => {
  const [estadoBotao, setEstadoBotao] = useState<EstadoBotaoProntuarioFamiliar>('DADOS_IMOVEL')

  const {
    data: { cidadao },
    loading,
  } = useProntuarioFamiliarQuery({
    fetchPolicy: 'cache-and-network',
    variables: { cidadaoId: cidadaoId },
    skip: !cidadaoId,
  })

  const cidadaoMudouSe = cidadao?.cidadaoNucleoFamiliar?.mudouSe
  const hasFamilias = cidadao?.familias?.length > 0
  const semFamilias = cidadaoMudouSe || !hasFamilias
  const familiasResidentes = hasFamilias && cidadao.familias

  return (
    <PageContent fluid type='filled'>
      <Grid>
        {loading || semFamilias ? (
          <SemFamiliaContainer cidadaoMudouSe={cidadaoMudouSe} semFamilia={semFamilias} loading={loading} />
        ) : (
          familiasResidentes?.map((familia, index) => {
            return (
              <Fragment key={familia.id}>
                <Cell size={12} key={familia.id}>
                  <FamiliaSection familia={familia} isProntuarioFamiliar isCardVulnerabilidade={index === 0} />
                </Cell>
                <Cell size={12}>
                  <ProntuarioFamiliarButtonGroup estadoBotao={estadoBotao} setEstadoBotao={setEstadoBotao} />
                </Cell>
                <Cell size={12}>
                  {estadoBotao === 'DADOS_IMOVEL' ? (
                    <>
                      <VisualizarImovelHeaderContent
                        imovel={convertImovelDtoToImovelHeaderDto(familia?.imovel)}
                        isProntuarioFamiliar
                      />
                      <CondicoesMoradiaSection
                        condicoesMoradia={familia?.imovel?.condicoesMoradia}
                        animais={familia?.imovel?.animaisImovel}
                        isProntuarioFamiliar
                      />
                    </>
                  ) : (
                    <ProntuarioFamiliarVisitasListSection imovelId={familia?.imovel?.id} />
                  )}
                </Cell>
              </Fragment>
            )
          })
        )}
      </Grid>
    </PageContent>
  )
}
